import React from "react";
import { toast } from "react-hot-toast";
/**
 * Show error notification using react-hot-toast
 * @param {string} message - Message to display in toast
 */
export const showErrorNotification = (message) => {
  toast.error(message, {
    id: "network_issue",
    duration: 4000,
    style: {
      border: "1px solid #ff4d4d",
      padding: "16px",
      background: "#ff4d4d",
      color: "#FFFAEE",
    },
    iconTheme: {
      secondary: "#ff4d4d",
      primary: "#FFFAEE",
    },
  });
};
